module.exports = __webpack_public_path__ + "static/img/leftLogo.e27e3d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/leftLogo.png
// module id = i0K1
// module chunks = 0